import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import 'sweetalert2/src/sweetalert2.scss';

const useFormFields = (initialFields) => {
    const [fields, setFields] = useState(initialFields);
    const [errors, setErrors] = useState(
        Object.keys(initialFields).reduce((acc, key) => ({ ...acc, [key]: false }), {})
    );

    const handleFieldChange = (key) => (e) => {
        const value = e.target.value;
        setFields({ ...fields, [key]: value });
        setErrors({ ...errors, [key]: false });
    };

    return { fields, errors, handleFieldChange, setFields, setErrors };
};

const validateFields = (fields, setErrors) => {
    const newErrors = {};
    let isValid = true;


    if (!fields.AccountName) {
        newErrors.AccountName = true;
        isValid = false;
    }
    if (!fields.Amount || parseFloat(fields.Amount) <= 0) {
        newErrors.Amount = true;
        isValid = false;
    }

    setErrors(newErrors);
    return isValid;
};

const VendorForm = ({ onSave }) => {
    const navigate = useNavigate();
    const token = localStorage.getItem("token");

    const initialFields = {
        Amount: '',
        AccountName: '',
    };

    const { fields, errors, handleFieldChange, setFields, setErrors } = useFormFields(initialFields);
    const [loading, setLoading] = useState(false);
    const [accountList, setAccountList] = useState([]);

    // Fetch account list for dropdown
    useEffect(() => {
        const fetchAccountList = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}Account-list`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
                setAccountList(response.data.data || []);
                if (response.data.data && response.data.data.length > 0) {
                    setFields((prev) => ({ ...prev, AccountName: response.data.data[0].id }));
                }
            } catch (error) {
                console.error('Error fetching account list:', error);
            }
        };
        fetchAccountList();
    }, [token, setFields]);

    const handleSubmit = async () => {
        const payload = {
            amount: fields.Amount,
            account_id: fields.AccountName,
            account_type: 'Online'
        
        };
    
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'Do you want to transfer the amount?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, transfer it!',
            cancelButtonText: 'No, cancel!',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        });
    
        if (result.isConfirmed) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}Self-Transter-Fund-Store`, payload, {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-access-token': token,
                    },
                });
    
                if (response.data.status === 1) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Amount transferred successfully!',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    setFields(initialFields);
                    onSave();
                    setTimeout(() => {
                        navigate('/Account-list');
                    }, 1000);
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: response.data.message || 'Something went wrong!',
                        icon: 'error',
                    });
                }
            } catch (error) {
                console.error('Error:', error);
                if (error.response) {
                    // Server error response
                    Swal.fire({
                        title: 'Error',
                        text: error.response.data.message || 'An error occurred during the transfer.',
                        icon: 'error',
                    });
                } else {
                    // Network or other errors
                    Swal.fire({
                        title: 'Error',
                        text: 'Network error or server is down. Please try again later.',
                        icon: 'error',
                    });
                }
            } finally {
                setLoading(false);
            }
        } else {
            Swal.fire('Cancelled', 'Transfer has been cancelled', 'info');
        }
    };
    

    const handleFormSubmit = () => {
        if (validateFields(fields, setErrors)) {
            setLoading(true);
            handleSubmit();
        }
    };

    return (
        <div id="selfTransferForm">
            <Card>
                <Card.Body>
                    <Container fluid>
                        <Row>
                        <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control
                                        type="number"
                                        placeholder="Enter Amount"
                                        value={fields.Amount}
                                        onChange={handleFieldChange('Amount')}
                                        className={errors.Amount ? 'is-invalid' : ''}
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Account Name</Form.Label>
                                    <Form.Select
                                        value={fields.AccountName}
                                        onChange={handleFieldChange('AccountName')}
                                        className={errors.AccountName ? 'is-invalid' : ''}
                                    >
                                        <option value="">Select</option>
                                        {accountList.map((account) => (
                                            <option key={account.id} value={account.id}>
                                                {account.account_name}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                       
                            {/* <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={fields.Date || new Date().toISOString().split("T")[0]}
                                        onChange={handleFieldChange('Date')}
                                        className={errors.Date ? 'is-invalid' : ''}
                                    />
                                </Form.Group>
                            </Col> */}
                            {/* <Col lg={4} sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Account Type</Form.Label>
                                    <Form.Select
                                        value={fields.AccountType}
                                        onChange={handleFieldChange('AccountType')}
                                        className={errors.AccountType ? 'is-invalid' : ''}
                                    >
                                        <option value="">Select Account Type</option>
                                        <option value="Cash">Cash</option>
                                        <option value="Online">Online</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col> */}
                        </Row>
                    </Container>
                </Card.Body>
                <Card.Footer>
                    <div className="d-flex justify-content-end">
                        <Button
                            variant="primary"
                            onClick={handleFormSubmit}
                            disabled={loading}
                        >
                            {loading ? 'Submitting...' : 'Transfer'}
                        </Button>
                    </div>
                </Card.Footer>
            </Card>
        </div>
    );
};

export default VendorForm;
